export default "__VITE_ASSET__BLaIJ47e__"